module.exports = __webpack_public_path__ + "environment.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=environment.js!./src/environment.js
// module id = 2498
// module chunks = 0